import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpEventType } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CloudService {

  idEmpresa: string;
  idUsuario: string;
  infoUsuario: any;
  idInstituto: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    this.idInstituto = this.authService.getInstituto();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    // console.log(infoUsu);
    this.idEmpresa = infoUsu.empresaId;
    this.infoUsuario = this.authService.getInfoUsuario();
  }

  getInstituto(){
    this.obtienInfo();
    return this.idInstituto;
  }

  getInfoUsuario(){
    return this.infoUsuario;
  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getProdCertAct(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  getProductoGestor(){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.productoGestor + this.idEmpresa,null);
  }

  // guardaArchivo(datos:any){
  //   this.obtienInfo();
  //   return this.http.post(DATOS_API.url + DATOS_API.endpoints.cargaArchivo + this.idEmpresa, datos);
  // }

  getArchivos(folder:string){
    this.obtienInfo();
    let datos = {nombreCarpeta: folder};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getArchivos + this.idEmpresa, datos);
  }

  getArchivosInstituto(instituto:number){
    this.obtienInfo();
    let datos = {instituto:instituto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getArchivosInstituto,datos);
  }

  eliminaArchivo(datos:any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.borraArchivo + this.idEmpresa,datos);
  }

  /////////////////////////

  getCarpetaRaiz(idEmpresa?:string){
    this.obtienInfo();
    if(localStorage.getItem('idPadre_temporal')){
      console.log("Existe padre temporal brothar");
      return this.http.get(DATOS_API.url + DATOS_API.endpoints.cloud.getRaiz + localStorage.getItem('idPadre_temporal'));
    }else{
      if(idEmpresa){
        return this.http.get(DATOS_API.url + DATOS_API.endpoints.cloud.getRaiz + idEmpresa);
      }
      else{
        return this.http.get(DATOS_API.url + DATOS_API.endpoints.cloud.getRaiz + this.idEmpresa);
      }
    }

  }

  getCarpeta(idCarpeta: string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.cloud.getCarpeta + idCarpeta);
  }

  guardaCarpeta(datos:any,idEmpresa?:string){
    // let datos = {
    //   nombre: "nombre",
    //   ubicacion: "raiz",
    //   carpetaId:  "id carpeta",  //solo cuando no es la raiz
    //   empresaId: "empresaId"
    // };
    if(idEmpresa){
      datos.empresaId = idEmpresa;
    }
    else{
      datos.empresaId = this.idEmpresa;
    }
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.cloud.saveCarpeta, datos);
  }

  guardaCarpetaITBM(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.cloud.saveCarpeta, datos);
  }

  guardaArchivo(datos) {
    return this.http.post<any>(DATOS_API.url + DATOS_API.endpoints.cloud.saveArchivo, datos, {
      reportProgress: true,
      observe: 'events'
    }).pipe(map((event) => {

      switch (event.type) {

        case HttpEventType.UploadProgress:
          const progress = Math.round(100 * event.loaded / event.total);
          return { status: 'progress', message: progress };

        case HttpEventType.Response:
          return event.body;

        default:
          return `Unhandled event: ${event.type}`;
      }
    })
  );
}

  guardaArchivoX(datos:any): Observable<any>{
    // let datos = {
    //   file: "archivo",
    //   ubicacion: "direccion completa de la carpeta",
    //   carpetaId:  "id carpeta"
    // };
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.cloud.saveArchivo, datos);
  }


  borraArchivo(idArchivo: string){
    return this.http.delete(DATOS_API.url + DATOS_API.endpoints.cloud.deleteArchivo + idArchivo);
  }

  borraCarpeta(idCarpeta: string){
    return this.http.delete(DATOS_API.url + DATOS_API.endpoints.cloud.deleteCarpeta + idCarpeta);
  }

  getInfoEmpresa(idEmpresa?:string){
    if(localStorage.getItem('idPadre_temporal')){ // ESTA COSA ESTA ASÏ PORQUE LOS CENTROS DE TRABAJO HIJOS DEBEN VER EL FILE MANAGER DEL ADMIN
      return this.http.get(DATOS_API.url + DATOS_API.endpoints.empresas + localStorage.getItem('idPadre_temporal'));
    }else{
      if(!idEmpresa){
        return this.http.get(DATOS_API.url + DATOS_API.endpoints.empresas + this.idEmpresa);
      }
      else{
        return this.http.get(DATOS_API.url + DATOS_API.endpoints.empresas + idEmpresa);
      }
    }
  }
  copiaArchivo(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.cloud.copyArchivo, datos);
  }

  ///// NUEVOS SERVICIOS FILE MANAGER
  getArchivos_nuevo(ruta:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.cloud.getArchivos + localStorage.getItem('companyID') + ruta);
  }
  getCarpetas_nuevo(folderId: string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.cloud.getCarpetas + localStorage.getItem('companyID') + '/' + folderId);
  }
  creaCarpeta_nuevo(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.cloud.guardaCarpeta, datos);
  }
  getArchivo_nuevo(nombreArchivo:string){
    return this.http.get(DATOS_API.endpoints.cloud.getArchivo + localStorage.getItem('companyID') + '/' + nombreArchivo);
  }
  guardaArchivo_nuevo(datos:any){
    return this.http.post<any>(DATOS_API.url + DATOS_API.endpoints.cloud.guardaArchivo, datos, {
      reportProgress: true,
      observe: 'events'
    }).pipe(map((event) => {
        switch (event.type) {

          case HttpEventType.UploadProgress:
            const progress = Math.round(100 * event.loaded / event.total);
            return { status: 'progress', message: progress };

          case HttpEventType.Response:
            return event.body;

          default:
            return `Unhandled event: ${event.type}`;
        }
      })
    )
  }
  borraArchivo_nuevo(path: string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.cloud.borraArchivo, {path});
  }

}
